import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import {
  AssignLeadGQL,
  AssignLeadMutationVariables,
  GlobalSearchBookingsGQL,
  GlobalSearchBookingsQuery,
  GlobalSearchClientsGQL,
  GlobalSearchClientsQuery,
  GlobalSearchLeadsGQL,
  GlobalSearchLeadsQuery,
  GlobalSearchOrdersGQL,
  GlobalSearchOrdersQuery,
  GlobalSearchResultNode,
} from '@generated/graphql';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  constructor(
    readonly globalSearchLeadsGQL: GlobalSearchLeadsGQL,
    readonly globalSearchClientsGQL: GlobalSearchClientsGQL,
    readonly globalSearchOrdersGQL: GlobalSearchOrdersGQL,
    readonly globalSearchBookingsGQL: GlobalSearchBookingsGQL,
    readonly assignLeadGQL: AssignLeadGQL,
  ) {}

  search(term: string) {
    const variables = { searchText: term };

    // One operator per query type: the four queries share the `globalSearch` field but not the
    // shape of its items, so the operator stays generic over the query it is piped into.
    const toResults = <T extends { globalSearch?: unknown }>() =>
      map(
        ({ data }: ApolloQueryResult<T>) => (data?.globalSearch ?? []) as GlobalSearchResultNode[],
      );

    return merge(
      this.globalSearchLeadsGQL.fetch(variables).pipe(toResults<GlobalSearchLeadsQuery>()),
      this.globalSearchClientsGQL.fetch(variables).pipe(toResults<GlobalSearchClientsQuery>()),
      this.globalSearchOrdersGQL.fetch(variables).pipe(toResults<GlobalSearchOrdersQuery>()),
      this.globalSearchBookingsGQL.fetch(variables).pipe(toResults<GlobalSearchBookingsQuery>()),
    );
  }

  assignLead(params: AssignLeadMutationVariables) {
    return this.assignLeadGQL.mutate(params).pipe(map(({ data }) => data?.assignLead?.ok));
  }
}
